import { envConfig } from "@configs/env.ts";
import { initGTM } from "@configs/gtm/gtm.ts";
import { initSentryManual } from "@configs/sentry/manual-sentry.ts";
import { initSentry } from "@configs/sentry/sentry.ts";
import { StatsigTracker } from "@configs/statsig/index.ts";
import "@styles/index.css";
import { NotificationPermissionState } from "@types";
import logger from "@utils/logger.ts";
import { getNotificationPermission } from "@utils/notification.ts";
import { getNotificationDrawerEnabled } from "@utils/server-config.ts";
import { SW_MEMBER_ID_STORAGE_KEY, updatePushSubscription } from "kz-ui-sdk";
import React from "react";
import ReactDOM from "react-dom/client";
import { EnhancedApp } from "./App.tsx";
import { swRegistration } from "./swRegistration.ts";

initSentry();
initSentryManual();
initGTM();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <EnhancedApp />
  </React.StrictMode>,
);

// Service worker registration
try {
  swRegistration({
    onReady: async () => {
      try {
        const isNotificationDrawerEnabled = await getNotificationDrawerEnabled();
        if (!isNotificationDrawerEnabled) {
          const memberId = sessionStorage.getItem(SW_MEMBER_ID_STORAGE_KEY) ?? undefined;

          const permission = getNotificationPermission();

          if (permission !== NotificationPermissionState.GRANTED) {
            // If permission is default, request permission and track the status
            if (permission === NotificationPermissionState.DEFAULT) {
              const tracker = StatsigTracker.getInstance();

              tracker.trackNotificationBrowserPromptShown();
              const requestedPermission = await Notification.requestPermission();
              tracker.trackNotificationSubscriptionStatus(requestedPermission as NotificationPermissionState);

              if (requestedPermission !== NotificationPermissionState.GRANTED) {
                return;
              }
            } else {
              // If permission is denied, do nothing
              return;
            }
          }

          await updatePushSubscription({
            memberId,
            accountId: envConfig.accountId,
            notificationURI: import.meta.env.VITE_PUSH_NOTIFICATION_URI,
            notificationTestParam: import.meta.env.VITE_TEST_NOTIFICATION_PARAM,
            publicUrl: import.meta.env.VITE_PUBLIC_URL,
          });
        }
      } catch (error) {
        logger._console.log("Set push subscription failed", error);
      }
    },
  }).register();
} catch (e) {
  logger._console.log("Service worker registration failed", e);
}
